import { Component } from '@angular/core';

import { EventCentreDialogService } from '../../event-centre-dialog.service';

import { TranslationKeyMap } from './tab-bar.component.i18n';

@Component({
    selector: 'cmps-event-centre-tab-bar',
    templateUrl: './tab-bar.component.html',
    host: {
        class: 'cmps-event-centre-tab-bar',
    },
})
export class TabBarComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    constructor(/** @private */ readonly _service: EventCentreDialogService) {}
}
